import script from "./StudentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentForm.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/student-information-form.css?vue&type=style&index=0&id=5593a240&scoped=true&lang=css&external"
import "./StudentForm.vue?vue&type=style&index=1&id=5593a240&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5593a240"]])

export default __exports__